import styled from "@emotion/styled";
import Button from "@material-ui/core/Button";
import { units } from "../../../../types/units";

export const CommentButton = styled(Button)`
  justify-content: center;
  padding: 0.25rem 1rem;
  border-radius: 50px;
  display: inline-block;
  min-width: 120px;
  font-weight: normal;
  ${units({
    backgroundColor: "lightGrey",
    "&.active": {
      backgroundColor: "transparent",
      borderColor: "deepSkyBlue",
      color: "deepSkyBlue",
    },
    fontSize: "small",
  })};
  &.active {
    border: 2px solid;
  }
`;
